/**
 * 애플리케이션 전역 상수 정의
 * 하드코딩된 값들을 중앙에서 관리하여 유지보수성 향상
 */

// ============================================
// 페이지네이션
// ============================================
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
  DEFAULT_PAGE: 1,
  // 페이지 타입별 기본값
  USER_MANAGEMENT_PAGE_SIZE: 20, // 사용자 관리 페이지 (목록이 많을 수 있어서 작은 값)
  STANDARD_PAGE_SIZE: 50, // 일반 페이지 (기본값)
} as const;

// ============================================
// 자동 승인 설정
// ============================================
export const AUTO_APPROVAL = {
  MAX_DOMAINS: 5,
  DEFAULT_MAX_DOMAINS: 5,
} as const;

// ============================================
// 플랜별 사용자 제한
// ============================================
export const PLAN_LIMITS = {
  PERSONAL: {
    min: 1,
    max: 1,
    default: 1,
  },
  PROFESSIONAL: {
    min: 1,
    max: 30,
    default: 10,
  },
  ENTERPRISE: {
    min: 1,
    max: null, // 무제한
    default: 30,
  },
} as const;

// ============================================
// 사용량 그래프 설정
// ============================================
export const USAGE_GRAPH = {
  DEFAULT_UNIT: 'hour' as const,
  DEFAULT_SCALE: 'auto' as const,
  HEIGHT: 240, // 픽셀
  MIN_BAR_HEIGHT: 4, // 픽셀
  QUICK_RANGES: {
    '24h': {
      label: '최근 24시간',
      unit: 'hour' as const,
      slots: 24,
    },
    '30d': {
      label: '최근 30일',
      unit: 'day' as const,
      slots: 30,
    },
    '90d': {
      label: '최근 90일',
      unit: 'day' as const,
      slots: 90,
    },
  },
} as const;

// ============================================
// 검색/필터링
// ============================================
export const SEARCH = {
  DEBOUNCE_DELAY: 500, // ms
  MIN_QUERY_LENGTH: 1,
} as const;

// ============================================
// 알림/메시지
// ============================================
export const NOTIFICATION = {
  DEFAULT_DURATION: 3000, // ms
  LONG_DURATION: 5000, // ms
  SHORT_DURATION: 2000, // ms
} as const;

// ============================================
// 차단 로그
// ============================================
export const BLOCKED_LOGS = {
  DEFAULT_DAYS: 28, // 최근 28일간의 차단 로그 조회
} as const;

// ============================================
// 크레딧
// ============================================
export const CREDIT = {
  TRIAL_USES: 5, // 체험판 기본 크레딧
  EXCHANGE_RATE: 100, // 10,000원 = 100 크레딧
} as const;

// ============================================
// 타입 정의 (상수와 함께 사용)
// ============================================
export type GraphUnit = typeof USAGE_GRAPH.DEFAULT_UNIT | 'day';
export type GraphScale = typeof USAGE_GRAPH.DEFAULT_SCALE | 'linear' | 'log';
export type QuickRange = keyof typeof USAGE_GRAPH.QUICK_RANGES;

// ============================================
// 다른 모듈에서 정의된 상수 및 타입 re-export
// ============================================
// 사용자 관리 관련
export { USER_MANAGEMENT_TABS, FILTER_VALUES } from './users';
export type { UserManagementTab } from './users';

// 고객사 관리 관련
export { CUSTOMER_MANAGEMENT_TABS } from './customers';
export type { CustomerManagementTab } from './customers';

// 서비스 관련
export { SERVICE_DASHBOARD_TABS } from './services';
export type { ServiceDashboardTab } from './services';

// 라우팅/메뉴 관련
export { MENU_VALUES, SUBMENU_VALUES } from './routing';
